// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1N1xT","type":"styles_type__KTs2d","choices":"styles_choices__wKj_p"};